import { useEffect, useState } from "react";

const PROPR_REFERRAL_URL = "https://app.propr.xyz/r/ALEXPAZ";

export default function PromoPopup({ user }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!user) return;
    const key = "promo_popup_seen_" + user.uid;
    const alreadySeen = sessionStorage.getItem(key);
    if (!alreadySeen) {
      setVisible(true);
      sessionStorage.setItem(key, "true");
    }
  }, [user]);

  if (!visible) return null;

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0,0,0,0.65)" }}>
      <div style={{ position: "relative", backgroundColor: "#111827", border: "1px solid rgba(59,130,246,0.4)", borderRadius: "16px", padding: "32px", maxWidth: "420px", width: "90%", textAlign: "center", boxShadow: "0 25px 50px rgba(0,0,0,0.5)" }}>
        <button onClick={() => setVisible(false)} style={{ position: "absolute", top: "12px", right: "16px", background: "none", border: "none", color: "#9ca3af", fontSize: "20px", cursor: "pointer" }}>✕</button>
        <div style={{ display: "inline-block", backgroundColor: "rgba(59,130,246,0.15)", border: "1px solid rgba(59,130,246,0.5)", color: "#60a5fa", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", padding: "4px 12px", borderRadius: "999px", marginBottom: "16px" }}>⚡ Featured Protocol</div>
        <h2 style={{ color: "#ffffff", fontSize: "22px", fontWeight: "700", marginBottom: "8px", marginTop: 0 }}>Farm Propr</h2>
        <p style={{ color: "#d1d5db", fontSize: "14px", marginBottom: "24px", marginTop: 0 }}>One of the most interesting airdrops right now. Start farming and accumulate points before TGE.</p>
        <a href={PROPR_REFERRAL_URL} target="_blank" rel="noopener noreferrer" style={{ display: "block", backgroundColor: "#3b82f6", color: "#ffffff", fontWeight: "700", fontSize: "15px", padding: "12px 24px", borderRadius: "12px", textDecoration: "none", marginBottom: "12px" }}>Farm Propr Now</a>
        <button onClick={() => setVisible(false)} style={{ background: "none", border: "none", color: "#6b7280", fontSize: "13px", cursor: "pointer" }}>Dismiss</button>
      </div>
    </div>
  );
}